import { render, staticRenderFns } from "./DeviceListTableSettings.vue?vue&type=template&id=54b01656&scoped=true"
import script from "./DeviceListTableSettings.vue?vue&type=script&lang=js"
export * from "./DeviceListTableSettings.vue?vue&type=script&lang=js"
import style0 from "./DeviceListTableSettings.vue?vue&type=style&index=0&id=54b01656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b01656",
  null
  
)

export default component.exports